import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setReturnQuestionary, setReturnQuestionaryFailure, setReturnQuestionaryIdle, setReturnQuestionarySuccess } from '../actions';

const set_return_questionary_status = handleActions(
  {
    [setReturnQuestionary.toString()]: (state, action) => 'LOADING',
    [setReturnQuestionarySuccess.toString()]: (state, action) => 'SUCCESS',
    [setReturnQuestionaryFailure.toString()]: (state, action) => 'FAILURE',
    [setReturnQuestionaryIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const set_return_questionary_data = handleActions(
  {
    [setReturnQuestionary.toString()]: () => null,
    [setReturnQuestionarySuccess.toString()]: (state, action) => action.payload,
    
  },
  null
);

export { set_return_questionary_status, set_return_questionary_data };
